import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

type Props = {
  name: string;
  inputType: 'text' | 'number' | 'tel';
  placeholder: string;
  required: boolean;
  label: string;
  validation: any;
  initialValue?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const SingleInputUnit: React.FC<Props> = ({
  name,
  inputType,
  placeholder,
  required,
  label,
  validation,
  initialValue,
  onChange,
}) => {
  const {
    register,
    formState: { errors },
    setValue,
  } = useFormContext();

  useEffect(() => {
    if(initialValue) setValue(name, initialValue);
  }, []); // eslint-disable-line

  return (
    <>
      <label className="form-label" htmlFor={name}>
        <span
          className={required ? 'form-label__required' : 'form-label__optional'}
        >
          {required ? '必須' : '任意'}
        </span>
        {label}
      </label>
      <input
        {...register(name, validation)}
        type={inputType}
        className={`form-input ${errors[name] && 'is-error'}`}
        placeholder={placeholder}
        id={name}
        onChange={onChange}
      />
    </>
  );
};
